import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import ReferralCard from "@/components/ReferralCard";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Gift, Users, Sparkles } from "lucide-react";

export default function ReferPage() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login?next=/refer" replace />;

  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-12" data-testid="refer-page">
      <SEO
        title="Refer & Earn — Get free contact reveals on To-Let Rentals"
        description="Invite friends to To-Let Rentals with your unique code. Both of you get 5 free owner-contact reveals for every friend who signs up. Zero brokerage, forever."
        path="/refer"
      />
      <Breadcrumbs items={[{ name: "Refer & Earn", path: "/refer" }]} />

      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-1 label-eyebrow text-[#C9A24A] mb-3">
          <Sparkles size={12} /> Give five · Get five
        </div>
        <h1 className="font-display text-4xl md:text-5xl text-[#7A1E2A] leading-tight mb-3">Invite friends, earn free reveals</h1>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          Every friend who signs up with your code gets <b>5 free owner-contact reveals</b> — and you get <b>5 more</b> too. Simple, forever.
        </p>
      </div>

      <ReferralCard />

      <div className="grid md:grid-cols-3 gap-4 mt-10">
        <HowStep
          num={1}
          icon={<Gift size={22} />}
          title="Share your code"
          body="Copy your unique code or share your link on WhatsApp in one tap."
        />
        <HowStep
          num={2}
          icon={<Users size={22} />}
          title="Friend signs up"
          body="They join To-Let Rentals with your code — completely free."
        />
        <HowStep
          num={3}
          icon={<Sparkles size={22} />}
          title="Both get rewarded"
          body="You each get 5 free contact reveals, added to your account instantly."
        />
      </div>
    </div>
  );
}

function HowStep({ num, icon, title, body }) {
  return (
    <div className="tlr-card p-5">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-[#FBF6EC] text-[#7A1E2A] flex items-center justify-center shrink-0">{icon}</div>
        <div>
          <p className="label-eyebrow text-gray-500">Step {num}</p>
          <h3 className="font-display text-lg text-[#7A1E2A] mt-1">{title}</h3>
          <p className="text-sm text-gray-600 mt-1 leading-relaxed">{body}</p>
        </div>
      </div>
    </div>
  );
}
